import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue';
import RcButton from '@components/RcButton/RcButton.vue';
import RcIcon from '@components/RcIcon/RcIcon.vue';
import { RcIconType } from '@components/RcIcon/types';
import type { IconTooltipContent } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcIconTooltip',
  props: {
    content: { default: null },
    label: { default: undefined },
    iconType: { default: 'info' }
  },
  setup(__props: any) {

/**
 * An icon that reveals a tooltip on hover, focus and activation.
 *
 * The icon itself is decorative and the button carries a generic accessible
 * name, so the tooltip text is announced as the button's description rather
 * than as its name.
 *
 * Example:
 *
 * <rc-icon-tooltip :content="t('workload.container.ports.toolTip')" />
 */
const TOOLTIP_TRIGGERS = ['hover', 'touch', 'focus', 'click'];

const props = __props;

const tooltip = computed(() => {
  if (!props.content) {
    return '';
  }

  const options = typeof props.content === 'string' ? { content: props.content } : { ...props.content };

  return { ...options, triggers: TOOLTIP_TRIGGERS };
});

return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return _withDirectives((_openBlock(), _createBlock(RcButton, {
    type: "button",
    variant: "ghost",
    size: "small",
    class: "rc-icon-tooltip",
    "aria-label": __props.label || _ctx.t('generic.moreInfo')
  }, {
    default: _withCtx(() => [
      _createVNode(RcIcon, { type: __props.iconType }, null, 8, ["type"])
    ]),
    _: 1
  }, 8, ["aria-label"])), [
    [_directive_clean_tooltip, tooltip.value]
  ])
}
}

})